import React, { useContext } from 'react';
import { createUseStyles } from 'react-jss';
import { ThemeContext } from 'styled-components';

import { ExcessFilterDropdown } from './excess_filter_dropdown';
import { CoverTypeFilterDropdown } from './cover_type_filter_dropdown';
import { PaymentFrequencyFilterDropdown } from './payment_frequency_filter_dropdown';

const useStyles = createUseStyles((theme) => ({
    filtersGroup: {
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        alignItems: 'center'
    },
    excessFilter: {
        paddingRight: '3.8rem'
    },
    coverTypeFilter: {
        paddingRight: '3.8rem'
    }
}));

const FiltersGroup = () => {
    const theme = useContext(ThemeContext);
    const classes = useStyles({ theme });

    return (
        <div className={classes.filtersGroup}>
            <div className={classes.excessFilter}><ExcessFilterDropdown /></div>
            <div className={classes.coverTypeFilter}><CoverTypeFilterDropdown /></div>
            <PaymentFrequencyFilterDropdown />
        </div>
    );
};

export { FiltersGroup };
